import localforage from 'localforage'
import Parse from 'parse'
import is from 'is_js'

Parse.serverURL = 'https://certificacaorblh.iff.fiocruz.br/parse'
Parse.initialize('CQBLH', 'JSKCQBLH')

const logRequests = process.env.DEBUG_MODE

function fetchFromCache (child) {
  logRequests && console.log(`fetching ${child}...`)
  return localforage.getItem(child).then(cacheChild => {
    if (cacheChild) {
      logRequests && console.log(`cache hit for ${child}.`)
      return Promise.resolve(cacheChild)
    } else {
      return Promise.reject(`O objeto não existe ou está corrompido.`)
      // return new Promise((resolve, reject) => {
      //   var childObject = Parse.Object.extend(child)
      //   var query = new Parse.Query(childObject)
      //   if (id) {
      //     query.get(id).then(childSnapshot => {
      //       if (childSnapshot) {
      //         childSnapshot.__lastUpdated = Date.now()
      //         localforage.setItem(child + '/' + id, childSnapshot)
      //         logRequests && console.log(`fetched ${child} id:${id}.`)
      //       }
      //       resolve(childSnapshot)
      //     })
      //   } else {
      //     query.find().then(childSnapshot => {
      //       if (childSnapshot) {
      //         localforage.setItem(child, childSnapshot)
      //         logRequests && console.log(`fetched ${child}`)
      //       }
      //       resolve(childSnapshot)
      //     })
      //   }
      // api.child(child).once('value', snapshot => {
      //   const val = snapshot.val()
      //   if (val) {
      //     val.__lastUpdated = Date.now()
      //     localforage.setItem(child, val)
      //     logRequests && console.log(`fetched ${child}.`)
      //   }
      //   resolve(val)
      // }, reject)
      // })
    }
  })
}

// Save locally on device storage
function save (child, val) {
  logRequests && console.log(`saving ${child}...`)
  return localforage
    .setItem(child, val)
    .then(value => {
      logRequests && console.log(`cache updated ${child}...`)
      return Promise.resolve(val)
    })
    .catch((err) => {
      logRequests &&
        console.log(`error occurred while updating cache for: ${child}...`)
      console.log(err.name)
      return Promise.reject(err)
    })
}

// function push (child, val) {
//   logRequests && console.log(`creating ${child}...`)
//   return localforage.setItem(child, val).then(value => {
//     logRequests && console.log(`cache created ${child}...`)
//     return Promise.resolve(val)
//     // return api.child(child).set(val).then(() => {
//     //   logRequests && console.log(`firebase created ${child}...`)
//     //   return Promise.resolve(val)
//     // })
//   })
// }

// function set(child, val) {
//   logRequests && console.log(`setting ${child}...`)

// return api
//   .child(child)
//   .set(val)
//   .then(() => {
//     logRequests && console.log(`first firebase ${child} setted...`)
//     return localforage.setItem(child, val).then(value => {
//       logRequests && console.log(`then cache setted ${child}...`)
//       return Promise.resolve(val)
//     })
//   })
// }
export function fetchUserBlhs (userId) {
  logRequests && console.log(`fetch user blh data...`)
  var childPath = `user_blh/${userId}`
  // first try fetching from internet
  if (is.online()) {
    let Blh = Parse.Object.extend('blh')
    let query = new Parse.Query(Blh)
    query.equalTo('userAdministrator', userId)
    return query
      .find()
      .then(blhsSnapshot => {
        var blhs = []
        blhsSnapshot.forEach(blhSnapshot => {
          var blh = {}
          blh.id = blhSnapshot.id
          blh.currentYear = blhSnapshot.get('currentYear')
          blh.name = blhSnapshot.get('name')
          blh.userAdministrator = blhSnapshot.get('userAdministrator')
          blhs.push(blh)
        })
        return save(childPath, blhs)
      })
      .catch(() => {
        return fetchFromCache(childPath).then(blhs => {
          console.log('USER BLHS from CACHE', blhs)
          return blhs
        })
      })
  } else {
    return fetchFromCache(childPath).then(blhs => {
      console.log('USER BLHS from CACHE', blhs)
      return blhs
    })
  }
}

export function fetchBLH (administratorId) {
  logRequests && console.log(`fetch blh data...`)
  var childPath = `blh/${administratorId}`
  return fetchFromCache(childPath)
    .then(blh => {
      console.log('BLH HIT FROM CACHE', blh)
      return blh
    })
    .catch(() => {
      let Blh = Parse.Object.extend('blh')
      let query = new Parse.Query(Blh)
      query.equalTo('userAdministrator', administratorId)
      return query.first().then(blhSnapshot => {
        var blh = {}
        blh.id = blhSnapshot.id
        blh.currentYear = blhSnapshot.get('currentYear')
        blh.name = blhSnapshot.get('name')
        blh.userAdministrator = blhSnapshot.get('userAdministrator')
        return save(childPath, blh)
      })
    })
}

export function fetchProcess (year, blhId) {
  logRequests && console.log(`fetch process data...`)
  // TODO: we should check for the latest version on the database first
  let childPath = `certification_process/${year}/${blhId}`
  return fetchFromCache(childPath)
    .then(process => {
      console.log('Process hit from cache', process)
      return process
    })
  /* return fetchFromCache(childPath).then(cachedProcess => {
    if (!cachedProcess) {
      return Promise.reject('Process not found')
    }

    if (is.online()) {
      var CertificationProcess = Parse.Object.extend('certification_process')
      var query = new Parse.Query(CertificationProcess)
      query.equalTo('blh', blhId)
      query.equalTo('year', year)
      query.greaterThan('syncedAt', cachedProcess.syncedAt)
      query.first().then(processSnapshot => {
        let syncedProcess = {}

      })
    }
    return Promise.resolve(cachedProcess)
  })
  if (is.online()) {
    // fetch from cloud
    var CertificationProcess = Parse.Object.extend('certification_process')
    var query = new Parse.Query(CertificationProcess)
    query.equalTo('blh', blhId)
    query.equalTo('year', year)
    return query.first().then(processSnap => {
      var process = {}
      if (!processSnap) {
        console.log('Process not found on cloud', processSnap)
        return null
      } else {
        process = processSnap.get('process')
        console.log('Process retrieved from cloud', process)
        return save(childPath, process)
      }
    }).catch((error) => {
      console.log(error)
      return fetchFromCache(childPath)
        .then(process => {
          console.log('Process hit from cache', process)
          return process
        })
    })
  } else {
    return fetchFromCache(childPath)
      .then(process => {
        console.log('Process hit from cache', process)
        return process
      })
  }
  */
}

export function createProcess (year, blhId) {
  logRequests && console.log(`creating new certification process...`)
  let certificationProcess = { status: 0, areas: [], id: '' }
  // if (is.online()) {
  //   return syncProcess(year, blhId, certificationProcess)
  // } else {
  return save(`certification_process/${year}/${blhId}`, certificationProcess)
  // }
}

export function setProcess (year, blhId, certificationProcess) {
  logRequests && console.log(`saving process data...${certificationProcess}`)
  // if (is.online()) {
  //   return syncProcess(year, blhId, certificationProcess)
  // } else {
  return save(`certification_process/${year}/${blhId}`, certificationProcess)
  // }
}

export function syncProcess (year, blhId, certificationProcess) {
  logRequests && console.log(`syncing process data...`)
  const CertificationProcess = Parse.Object.extend('certification_process')
  var ProcessObj = new CertificationProcess()
  if (certificationProcess.id) {
    var query = new Parse.Query(CertificationProcess)
    return query.get(certificationProcess.id).then((certObj) => {
      ProcessObj = certObj
      certificationProcess.id = ProcessObj.id
      ProcessObj.set('process', certificationProcess)
      ProcessObj.set('year', year)
      ProcessObj.set('blh', blhId)
      return ProcessObj.save().then((process) => {
        return save(`certification_process/${year}/${blhId}`, certificationProcess)
      })
    })
  } else {
    ProcessObj.set('process', certificationProcess)
    ProcessObj.set('year', year)
    ProcessObj.set('blh', blhId)
    return ProcessObj.save().then((process) => {
      certificationProcess.id = process.id
      ProcessObj.set('process', certificationProcess)
      return ProcessObj.save().then(() => {
        return save(`certification_process/${year}/${blhId}`, certificationProcess)
      })
    })
  }
  // return set(`certification_process/${year}/${uid}`, certificationProcess)
}

export function deleteImage (id) {
  return localforage.removeItem(`image/${id}`)
}

export function setImage (id, image) {
  logRequests && console.log(`saving image data...`)
  return save(`image/${id}`, image)
}

export function fetchImage (id) {
  logRequests && console.log(`fetching image data...`)
  return fetchFromCache(`image/${id}`)
}

export function fetchImages (ids) {
  return Promise.all(ids.map(id => fetchImage(id)))
}

export function fetchEquipments () {
  logRequests && console.log(`fetch equipment data...`)
  // First fetch from internet, then from cache
  if (is.online()) {
    let Equipments = Parse.Object.extend('equipments')
    let query = new Parse.Query(Equipments)
    return query
      .ascending('name')
      .find()
      .then(equipmentList => {
        var equipmentArray = [equipmentList.length]
        for (let i = 0; i < equipmentList.length; i++) {
          var equipment = {}
          equipment.name = equipmentList[i].get('name')
          equipment.photos = equipmentList[i].get('photos')
          equipment.id = equipmentList[i].id
          equipment.index = i
          equipmentArray[i] = equipment
        }
        return save('equipments/', equipmentArray)
      })
      .catch(() => {
        return fetchFromCache(`equipments/`)
      })
  } else {
    return fetchFromCache(`equipments/`)
  }
}

export function saveFile (file, name) {
  var parseFile = new Parse.File(name, file)

  return parseFile.save().then(file => {
    console.log(file.url())
    return file.url()
  })
}

export function isAuthenticated () {
  logRequests && console.log(`fetch current user...`)
  var currentUser = Parse.User.current()
  return localforage.getItem('uid').then(localUser => {
    logRequests && console.log('localUser from cache:' + localUser)
    if (localUser) {
      return Promise.resolve(localUser)
    } else if (currentUser) {
      logRequests && console.log('localUser from firebase:' + currentUser)
      return localforage.setItem('uid', currentUser.id)
    } else {
      return Promise.reject(false)
    }
  })
}

export function logoutUser () {
  return localforage.setItem('uid', null).then(() => {
    return Parse.User.logOut()
  })
}

export function authenticateUser (email, password) {
  logRequests && console.log(`authenticating ${email}...`)
  logRequests && console.log(`reaching firebase for ${email}...`)
  return Parse.User.logIn(email, password)
    .then(user => {
      console.log(user)
      logRequests &&
        console.log(`authentication success for ${email} uid:${user.id} `)
      return localforage.setItem('uid', user.id)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export function fetchAreas () {
  logRequests && console.log(`fetch areas data...`)
  // First fetch from internet, then from cache
  var Areas = Parse.Object.extend('areas')
  var query = new Parse.Query(Areas)
  return query
    .ascending('name')
    .find()
    .then(areasList => {
      var areasArray = [areasList.length]
      for (let i = 0; i < areasList.length; i++) {
        var area = {}
        area.name = areasList[i].get('name')
        area.required = areasList[i].get('required')
        area.id = areasList[i].id
        area.index = i
        areasArray[i] = area
      }
      return save('areas/', areasArray)
    })
    .catch(() => {
      return fetchFromCache(`areas/`)
    })
}

export function fetchConfig (config) {
  logRequests && console.log(`fetching parse config ${config}`)
  if (is.online()) {
    return Parse.Config.get().then(configSnapshot => {
      let returnedConfig = configSnapshot.get(config)
      logRequests &&
        console.log(`parse config-${config} fetched: ${returnedConfig} `)
      return save(`configs/${config}/`, returnedConfig)
    }).catch(() => {
      return fetchFromCache(`configs/${config}/`)
    })
  } else {
    return fetchFromCache(`configs/${config}/`)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js